export default __webpack_public_path__ + "static/O0181-3810724a2a9e95116845c362ab53a5e7.png";